import React from 'react';

/**
 * StatusDot — completion indicator.
 * complete → green, partial → amber, none → gray.
 * Pass explicit `state` ('complete' | 'partial' | 'none'), or `complete`/`partial` booleans.
 */
function StatusDot({ state, complete, partial, title }) {
  const resolved = state || (complete ? 'complete' : partial ? 'partial' : 'none');
  const color =
    resolved === 'complete' ? 'var(--color-success)' :
    resolved === 'partial' ? 'var(--color-warning)' :
    'var(--lodge-onyx-200)';
  const label = title || (resolved === 'complete' ? 'Complete' : resolved === 'partial' ? 'Partially configured' : 'Not configured');
  return (
    <div
      title={label}
      style={{ width: 8, height: 8, borderRadius: '50%', background: color, margin: '0 auto', transition: 'background .3s' }}
    />
  );
}

export default StatusDot;
